import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { SasDynamicFormService } from '../sas-dynamic-form.service';
import { FormSubmittedService } from '@services';

@Component({
    selector: 'sas-radiobutton-field-type',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule],
    providers: [],
    template: `
        <div class="form-group-radio mb-3">
            @if(field.props.label){
            <label [for]="field.id"
                   [id]="field.id + '-group-label'"
                   class="radio-legend"
                   [title]="helpText"
                   translate="{{field.props.label}}">
            </label>
            @if(field.props.required){
            <span> *</span>
            }
            }
            <fieldset class="sas-radiobutton" role="radiogroup" [attr.aria-labelledby]="field.props.label ? field.id + '-group-label' : null">
                @if (helpText.length) {
                <div [title]="helpText" class="sas-inline-block">
                    <i class="bi bi-info-circle-fill sas-info-icon" aria-hidden="true"></i>
                </div>
                }
                @for (val of sasValues; track $index) {
                <span [ngClass]="{
                    'sas-radiobutton-option--stacked': field.props['orientation'] === 'vertical',
                    'is-invalid' : field.formControl.invalid && (field.formControl.touched || formSubmittedService.isSubmitted())
                }">
                    <input type="radio"
                           id="{{field.name! + $index}}"
                           [formControl]="formControl"
                           class="radio form-check-input"
                           [ngClass]="{'check': formControl.value === val, 'is-invalid' : field.formControl.invalid && (field.formControl.touched || formSubmittedService.isSubmitted())}"
                           name="{{field.name}}"
                           title="{{helpText}}"
                           tabindex="0"
                           [value]="val"
                           [required]="field.props.required ?? false"/>
                    <label [for]="field.name! + $index"
                            [id]="field.name! + $index + '-label'"
                            class="radio form-check-label"
                            title="{{helpText}}"
                            [textContent]="sasLabels[$index] | translate"
                            (keydown)="keyHandler($event, val)">
                    </label>
                </span>
                }
                @if (field.formControl.invalid && (field.formControl.touched || formSubmittedService.isSubmitted()) && field.formControl.errors?.['required']) {
                <div [id]="field.id + 'Desc'" role="alert" class="invalid-feedback" aria-atomic="true">
                    <small>{{ sasDynamicFormService.getFieldErrorMessage(field) }}</small>
                </div>
                }
            </fieldset>
        </div>
    `,
    styleUrl: './sas-radiobutton-field-type.component.scss'
})

export class SasRadiobuttonFieldTypeComponent extends FieldType<FieldTypeConfig> {
    formSubmittedService = inject(FormSubmittedService);
    private translate = inject(TranslateService);
    sasDynamicFormService = inject(SasDynamicFormService);

    helpText: string = '';
    sasLabels: any = [];
    sasValues: any = [];

    ngOnInit() {
        if (this.field.props['helptext']) {
            const helpText = this.translate.instant(this.field.props['helptext']);

            this.helpText = helpText === this.field.props['helptext'] ? '' : helpText;
        }

        this.sasLabels = this.convertToArray(this.field.props['labels']) || [];
        this.sasValues = this.convertToArray(this.field.props['values']) || [];
    }

    convertToArray(value: string) {
        const array = value.replace(/'/g, '"') //replacing all ' with "
        return JSON.parse(array);
    }

    keyHandler(event: KeyboardEvent, value: any) {
        if (!this.field.props.disabled && (event.key === ' ' || event.key === 'Enter')) {
            this.formControl.setValue(value);
        }
    }
}
